<template>
  <div class="transport-systems">
    <r-text type="caption" style="margin-bottom: 4px;">
      Настройте список активных систем транспорта для данной модели
    </r-text>
    <ul class="transport-systems-list">
      <transport-system-item
        v-for="item in systems"
        :system="item"
        :loading-item="loadingItem"
        :key="item.id"
        @click="toggleSystem"
      >
        <el-switch class="r-switch" v-model="item.enabled" />
      </transport-system-item>
    </ul>
  </div>
</template>

<script>
import TransportSystemItem from "./transport-system-item";

export default {
  props: ["controller"],
  components: {
    TransportSystemItem
  },
  data() {
    return {
      loadingItem: null
    };
  },
  computed: {
    systems() {
      return this.$store.state.trafficCount.model.transport_systems
        .map(a => a)
        .sort((a, b) => {
          if (a.code > b.code) return 1;
          if (a.code < b.code) return -1;
          return 0;
        });
    }
  },
  methods: {
    async toggleSystem(system) {
      if (this.loadingItem) return;

      try {
        const { ids } = this.$store.state.trafficCount.model;
        const value = !system.enabled;
        this.loadingItem = system.id;
        // this.$set(system, "enabled", value);
        const url = `objectInfo/${ids["sys_set_measures"]}`;
        const data = { id: system.id, enabled: value };
        await this.$store.dispatch("POST_REQUEST", { url, data });
        this.controller.setTransportSystems(ids);
        this.loadingItem = null;
      } catch (error) {
        console.log(error);
        this.loadingItem = null;
      }
    }
  }
};
</script>

<style lang="scss">
.transport-systems {
  &-list {
    padding: 8px 0;
    max-height: 40vh;
    overflow: auto;
  }
}
</style>
